"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _findLastWithKey = _interopRequireDefault(require("../find-last-with-key"));
var _saleableProductIdsKeyedByDate = _interopRequireDefault(require("./saleable-product-ids-keyed-by-date"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getSaleableProductsKeyedByType = function getSaleableProductsKeyedByType(date) {
  return (0, _findLastWithKey["default"])(function (products, saleableDate) {
    return (0, _moment["default"])(saleableDate, _moment["default"].ISO_8601, true).isSameOrBefore(date);
  }, _saleableProductIdsKeyedByDate["default"]);
};
var _default = exports["default"] = getSaleableProductsKeyedByType;
module.exports = exports.default;